export type ModeId = 'draw-guess' | 'relay-rescue' | 'live-draw' | 'doodle-flight';
export const SUPPORTED_MODES = 'draw-guess,relay-rescue,live-draw,doodle-flight';
export const GAME_MODES = [
  { id: 'draw-guess', name: '友友画猜', description: '留下一幅画，等好友猜中心意。', icon: 'brush', color: '#2274B8', tint: '#E1F0FA' },
  { id: 'relay-rescue', name: '接笔救援', description: '接住昨天的画笔，一起画路闯关。', icon: 'heart', color: '#327E66', tint: '#E0F1E8' },
  { id: 'live-draw', name: '画猜派对', description: '此刻一起画，好友一起猜。', icon: 'palette', color: '#C74522', tint: '#FBE3D2' },
  { id: 'doodle-flight', name: '涂鸦战机', description: '画出自己的战机，一起挑战无尽天空。', icon: 'plane', color: '#3F8F87', tint: '#DDEEE5' },
] as const;
export const modeInfo = (id: ModeId = 'draw-guess') => GAME_MODES.find(mode => mode.id === id)!;
export const modeOf = (value: { mode?: ModeId }) => value.mode ?? 'draw-guess';
export interface Conversation {
  id: string; mode?: ModeId; members: string[]; status: 'inviting' | 'active' | 'closed';
  inviteCode: string; inviteExpiresAt: number; updatedAt: number;
}
export interface ConversationSummary {
  id: string; mode?: ModeId; partner: string; partnerAvatarUrl?: string; partnerOnline?: boolean;
  status: Conversation['status']; action: 'draw' | 'guess' | 'wait' | 'review' | 'closed' | 'record' | 'receive' | 'replay';
  number: number; solved: number; updatedAt: number; progressLabel?: string;
}
